<template>
  <ul class="item">
    <li class="gray">
      <span class="label">标题：</span>
      <span class="text">{{data.title}}</span>
    </li>
    <li>
      <span class="label">发件人：</span>
      <span class="text">{{formatff(data.type)}}</span>
    </li>
    <li>
      <span class="label">发送时间：</span>
      <span class="text">{{data.created_at*1000 | formatDate}}</span>
    </li>
    <li class="content">
      <p>{{data.message}}</p>
    </li>
  </ul>
</template>

<script>
import { formatDate } from '@/common/js/common'

export default {
  name: 'item',
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    formatff(status) {
      let ret = ''
      switch (status) {
        case 1:
          ret = '系统公告'
          break
        case 2:
          ret = '系统消息'
          break
        case 3:
          ret = '站长消息'
          break
        default:
          break
      }
      return ret
    }
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  }
}
</script>

<style lang="stylus" scoped>
.item
  margin 30px auto 0
  width 919px
  border-top 1px solid #dcdcdc
  & > li
    border 1px solid #dcdcdc
    border-top none
    display flex
    font-size 14px
    .label
      display inline-block
      width 77px
      padding 0 18px 0 0
      border-right 1px solid #dcdcdc
      text-align right
      line-height 42px
      height 42px
    .text
      padding 0 0 0 18px
      line-height 42px
      height 42px
  .content
    padding 14px 18px
    height 95px
    & > p
      text-indent 2em
  .gray
    background #efefef
</style>



// WEBPACK FOOTER //
// item.vue?123def3a